/** Настройки участника, переживающие перезагрузку страницы. */

import { normalizeAudioMode, type AudioMode } from './audio';
import type { CodecPreference } from './codec';
import type { VideoMode } from './video';

const KEY = 'gto-connect:prefs:v3';

export interface Prefs {
  name: string;
  cameraId: string;
  micId: string;
  speakerId: string;
  cameraEnabled: boolean;
  micEnabled: boolean;
  codec: CodecPreference;
  videoMode: VideoMode;
  audioMode: AudioMode;
  noiseSuppression: boolean;
}

const DEFAULTS: Prefs = {
  name: '',
  cameraId: '',
  micId: '',
  speakerId: '',
  cameraEnabled: true,
  micEnabled: true,
  codec: 'auto',
  videoMode: 'auto',
  audioMode: 'auto',
  noiseSuppression: true,
};

export function loadPrefs(): Prefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const saved = { ...DEFAULTS, ...JSON.parse(raw) };
    // Режим звука мог быть сохранён под именем, которого больше нет
    // («Высокое качество»). Приводим к живому — иначе человек попал бы
    // в режим без подписи и без битрейта.
    return { ...saved, audioMode: normalizeAudioMode(saved.audioMode) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePrefs(patch: Partial<Prefs>): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...loadPrefs(), ...patch }));
  } catch {
    // Приватный режим браузера — не критично, работаем без сохранения.
  }
}
